import { render } from "./CardModal.vue?vue&type=template&id=0648c0d2&scoped=true"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"

import "./CardModal.vue?vue&type=style&index=0&id=0648c0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0648c0d2"]])

export default __exports__